import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TransactionGt, TransactionStatus, TrackingStatus } from 'src/app/models/transaction';
import { AppConstants } from "src/app/app_setting/app-constants";

@Component({
  selector: 'app-transaction-detail-gt',
  templateUrl: './transaction-detail-gt.component.html',
  styleUrls: ['./transaction-detail-gt.component.css']
})
export class TransactionDetailGtComponent implements OnInit {

  @Input() transaction: TransactionGt = new TransactionGt();
  @Output() backToList: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelTransactionConfirmation: EventEmitter<any> = new EventEmitter<any>();

  status: string;
  startPrice = 0;
  totalDiscount = 0;
  tax = 0;
  priceAfterTax = 0;
  sealFee = 0;
  finalPrice = 0;
  priceBeforeTax = 0;

  constructor(public datepipe: DatePipe) { }

  public get getTransactionStatus() {
    return TransactionStatus;
  }

  public get getTrackingStatus() {
    return TrackingStatus;
  }

  ngOnInit() {
    const data = this.transaction as any;

    this.startPrice = data.totalPrice;
    this.tax = data.totalPpn;
    this.totalDiscount = data.totalDiscount;
    this.priceAfterTax = data.grandTotal;
    // this.sealFee = data.total_materai;
    this.priceBeforeTax = data.totalPrice - data.totalDiscount;
    this.finalPrice = data.grandTotal;
    // if (this.transaction.show_price_detail) {
    //   this.transaction.total = this.finalPrice;
    // }

    switch (this.transaction.transactionStatus) {
      case 1:
        this.status = "Menunggu Upload Bukti Transfer";
        break;
      case 2:
        this.status = "Diterima";
        break;
      case 3:
        this.status = "Ditolak";
        break;
      default:
        this.status = "Pesanan Dibuat";
        break;
    }
  }

  back() {
    this.backToList.emit();
  }

  changeSource(event) {
    event.target.src = AppConstants.ProductImageDefault;
  }

  resolveProductImage(imageUrl: string): string {
    if (imageUrl === null || imageUrl === "" || imageUrl === undefined) {
      return AppConstants.ProductImageDefault;
    }

    return imageUrl;
  }

  getFileName(path, isExtension){

    var fullFileName, fileNameWithoutExtension;

    // replace \ to /
    while( path.indexOf("\\") !== -1 ){
      path = path.replace("\\", "/");
    }

    fullFileName = path.split("/").pop();
    return (isExtension) ? fullFileName : fullFileName.slice( 0, fullFileName.lastIndexOf(".") );
  }

  cancelTransaction(transaction: TransactionGt) {
    this.cancelTransactionConfirmation.emit(transaction);
  }
}
